<hlm-dialog-header>
  <h3 hlmDialogTitle>Test Environment</h3>
</hlm-dialog-header>
<div class="content">
  <p>This system is used for evaluation purposes only. Any data entered here will not be reflected in the actual system.</p>
</div>
<hlm-dialog-footer [class]="'flex justify-center items-center gap-1'">
  <label>
    <input type="checkbox" class="accept-box" [(ngModel)]="savePreference">
    Don't show this again today
  </label>

  <button class="button button--green-fill button--xs" (click)="onYesClick()">I Understand</button>
</hlm-dialog-footer>
